import { render, staticRenderFns } from "./PortfoliosTotal.vue?vue&type=template&id=59fbf27a&scoped=true&"
import script from "./PortfoliosTotal.vue?vue&type=script&lang=js&"
export * from "./PortfoliosTotal.vue?vue&type=script&lang=js&"
import style0 from "./PortfoliosTotal.vue?vue&type=style&index=0&id=59fbf27a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fbf27a",
  null
  
)

export default component.exports